/* One dependency shared by all sections, including recommendations on /cart. */
(() => {
  let pending;
  function load() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (pending) return pending;
    pending = new Promise((resolve,reject) => {
      const css=document.createElement('link');css.rel='stylesheet';css.href='https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      const js=document.createElement('script');js.src='https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      let styleReady=false,scriptReady=false;
      const ready=()=>{if(styleReady&&scriptReady) resolve(window.Swiper);};
      css.onload=()=>{styleReady=true;ready();};js.onload=()=>{scriptReady=true;ready();};
      css.onerror=js.onerror=reject;document.head.append(css,js);
    });
    return pending;
  }
  Object.defineProperty(window,'GerhelSwiperReady',{get:load});
  function init(){if(document.querySelector('.swiper')) load().catch(()=>{});}
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
